import { Component, inject, OnInit } from '@angular/core';

import { Router } from '@angular/router';
import { QfaEventType } from '../../../shared/enums/event-type.enum';
import { AuthService } from '../../../shared/services/auth.service';
import { LoggingService } from '../../../shared/services/logging.service';

/**
 * This component is what the salesforce login screen redirects to
 * It handles the success/error and then redirects ot the original url the user attempted ot view i.e dashboard page or policy coverage page OR the access denied page
 */
@Component({
  selector: 'app-oauth-callback',
  imports: [],
  template: '',
})
export class OAuthCallbackScreenComponent implements OnInit {
  protected readonly _oauthService: AuthService = inject(AuthService);
  protected readonly _router: Router = inject(Router);
  protected readonly _loggingService: LoggingService = inject(LoggingService);

  ngOnInit() {
    this._oauthService
      .completeLoginOAuthCallback()
      .then(() => this.handleOAuthSuccess())
      .catch(() => this.handleOAuthFailure());
  }

  handleOAuthSuccess() {
    const originalUrl = sessionStorage.getItem('originalUrl');
    this._loggingService.logEvent(QfaEventType.DEBUG, 'OAuth success.');
    const redirectUrl = originalUrl ?? '/';
    this._router.navigateByUrl(redirectUrl);
  }

  handleOAuthFailure() {
    this._loggingService.logEvent(QfaEventType.DEBUG, 'OAuth failed.');
    this._router.navigate(['/access-denied']);
  }
}
